var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[(_vm.show)?_c('v-btn',{staticClass:"ma-4",attrs:{"bottom":"","color":"primary","fab":"","fixed":"","right":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('v-icon',[_vm._v(_vm._s((_vm.icon + '').trim()))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }